import pimg1 from '../images/projects/1.png'
import pimg2 from '../images/projects/2.png'
import pimg3 from '../images/projects/3.png'
import pimg4 from '../images/projects/4.png'
import pimg5 from '../images/projects/5.png'
import pimg6 from '../images/projects/6.png'
import pimg7 from '../images/projects/6.jpg'
import pimg8 from '../images/projects/7.jpg'
import pimg9 from '../images/projects/8.jpg'
import pimg10 from '../images/projects/9.jpg'
import pimg11 from '../images/projects/10.jpg'
import pimg12 from '../images/projects/3.png'
import pimg13 from '../images/projects/2.png'
import pimg14 from '../images/projects/1.png'

import ps1img1 from '../images/project-single/1.png'
import ps1img2 from '../images/project-single/2.jpg'
import ps1img3 from '../images/project-single/3.jpg'
import ps1img4 from '../images/project-single/4.jpg'
import ps1img5 from '../images/project-single/5.jpg'
import ps1img6 from '../images/project-single/6.jpg'
import ps1img7 from '../images/project-single/7.jpg'
import ps1img8 from '../images/project-single/8.jpg'
import ps1img9 from '../images/project-single/9.jpg'
import ps1img10 from '../images/project-single/11.jpg'
import ps1img11 from '../images/project-single/10.jpg'
import ps1img12 from '../images/project-single/12.jpg'
import ps1img13 from '../images/project-single/13.jpg'
import ps1img14 from '../images/project-single/14.jpg'


import psub1img1 from '../images/project-single/1.png'
import psub1img2 from '../images/project-single/2.png'


const Projects = [
    {
       Id:'1',
       pImg:pimg1,
       ps1img:ps1img1,
       psub1img1:psub1img1,
       psub1img2:psub1img2,
       title:'RIAD BALA',  
       subTitle:'Riad Catalia : piscine exclusive et chauffée',  
       section1:{ 
         description:"Le Riad Catalia est un lieu magique, où les arômes, les sons, les goûts et les sensations vous font ressentir le pouls de la séduisante Ville Rouge Dans la médina, à 3mins de Jamaa Alfna, en passant par le souk, et c'est riad de charme avec piscine et une magnifique terrasse.",
         description1:"Le riad peut accueillir jusqu'à 8 personnes, offrant 4 chambres et 4 salles de bains. Il est réservé exclusivement à vous et à vos compagnons de voyage.Bienvenue au Riad CATALIA, le nouveau bijou de Marrakech caché au cœur de la Médina. Idéalement dans le quartier RIAD ZITOUN LAKDIM, ce riad privatif para-hôtelier offrira une oasis de tranquillité au milieu de l'effervescence de la Médina.",
         details:[
            "Location :   Marrakech, Medina Kasbah ",
            "Client :    Jean Pierre",
            "Project Type :  Riad ",
            "Completion :  15 Mars 2024",
            "Duration :   6 mois"
        ]
      }, 
    },
    {
       Id:'2',
       pImg:pimg2,
       ps1img:ps1img2,
       psub1img1:psub1img1,
       psub1img2:psub1img2,
       title:'RIAD', 
       subTitle:'RIAD LALA YAMINA',    
    },
    {
      Id:'3',
      pImg:pimg3,
      ps1img:ps1img3,
      psub1img1:psub1img1,
      psub1img2:psub1img2,
      title:'RIAD',  
      subTitle:'RIAD KARAM',   
   },
    {
       Id:'4',
       pImg:pimg4,
       ps1img:ps1img4,
       psub1img1:psub1img1,
       psub1img2:psub1img2,
       title:'RIAD',  
       subTitle:'RIAD SALIM', 
    },
    {
       Id:'5',
       pImg:pimg5,
       ps1img:ps1img5,
       psub1img1:psub1img1,
       psub1img2:psub1img2,
       title:'RIAD',  
       subTitle:'RIAD JAD',   
    },
    {
       Id:'6',
       pImg:pimg6,
       ps1img:ps1img6,
       psub1img1:psub1img1,
       psub1img2:psub1img2,
       title:'RIAD', 
       subTitle:'DAR MBAREK',    
    },
    {
      Id:'7',
      pImg:pimg7,
      ps1img:ps1img7,
      psub1img1:psub1img1,
      psub1img2:psub1img2,
      title:'Interior', 
      subTitle:'Interior Design',  
   },
    {
       Id:'8',
       pImg:pimg8,
       ps1img:ps1img8,
       psub1img1:psub1img1,
       psub1img2:psub1img2,
       title:'Interior', 
       subTitle:'Interior Design',
    },
    {
       Id:'9',
       pImg:pimg9,
       ps1img:ps1img9,
       psub1img1:psub1img1,
       psub1img2:psub1img2,
       title:'Architecture',  
      subTitle:'Architecture Design', 
    },
    {
      Id:'10',
      pImg:pimg1,
      ps1img:ps1img1,
      psub1img1:psub1img1,
      psub1img2:psub1img2,
      title:'Architecture',  
      subTitle:'Architecture Design',   
   },
   {
      Id:'11',
      pImg:pimg2,
      ps1img:ps1img2,
      psub1img1:psub1img1,
      psub1img2:psub1img2,
      title:'Interior', 
      subTitle:'Interior Design',    
   },
   {
     Id:'12',
     pImg:pimg3,
     ps1img:ps1img3,
     psub1img1:psub1img1,
     psub1img2:psub1img2,
     title:'RIAD',  
     subTitle:'RIAD KARAM',   
  },
   {
     Id:'13',
     pImg:pimg10,
     ps1img:ps1img10,
     psub1img1:psub1img1,
     psub1img2:psub1img2,
     title:'Architecture',  
     subTitle:'Architecture Design',   
  },
   {
     Id:'14',
     pImg:pimg11,
     ps1img:ps1img11,
     psub1img1:psub1img1,
     psub1img2:psub1img2,
     title:'Architecture',  
     subTitle:'Architecture Design',   
  },
   {
     Id:'15',
     pImg:pimg12,
     ps1img:ps1img12,
     psub1img1:psub1img1,
     psub1img2:psub1img2,
     title:'RIAD',  
     subTitle:'RIAD LALA SAADIA',   
  },
   {
     Id:'16',
     pImg:pimg13,
     ps1img:ps1img13,
     psub1img1:psub1img1,
     psub1img2:psub1img2,
     title:'RIAD',  
     subTitle:'RIAD LALA B&Z',   
  },
   {
     Id:'17',
     pImg:pimg14,
     ps1img:ps1img14,
     psub1img1:psub1img1,
     psub1img2:psub1img2,
     title:'RIAD',  
     subTitle:'RIAD KARAM',   
  },
   {
     Id:'18',
    pImg:pimg13,
     ps1img:ps1img13,
     psub1img1:psub1img1,
     psub1img2:psub1img2,
     title:'RIAD',  
     subTitle:'DAR EL BACHA',    
  },
    
]

export default Projects;